/* tslint:disable */
/* eslint-disable */
/**
 * Example API
 * API description
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface UpdateStopRequest
 */
export interface UpdateStopRequest {
    /**
     * 
     * @type {string}
     * @memberof UpdateStopRequest
     */
    title?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateStopRequest
     */
    description?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateStopRequest
     */
    highlight?: string;
    /**
     * New position/order of the stop within the day. Other stops will be reordered automatically.
     * @type {number}
     * @memberof UpdateStopRequest
     */
    index?: number;
    /**
     * 
     * @type {Array<string>}
     * @memberof UpdateStopRequest
     */
    dayIds?: Array<string>;
    /**
     * 
     * @type {string}
     * @memberof UpdateStopRequest
     */
    imageUrl?: string;
    /**
     * ID of the associated image entity
     * @type {string}
     * @memberof UpdateStopRequest
     */
    imageId?: string;
    /**
     * State of the stop - used to accept or reject AI suggestions
     * @type {string}
     * @memberof UpdateStopRequest
     */
    state?: UpdateStopRequestStateEnum;
}


/**
 * @export
 */
export const UpdateStopRequestStateEnum = {
    Suggested: 'SUGGESTED',
    Accepted: 'ACCEPTED',
    Rejected: 'REJECTED'
} as const;
export type UpdateStopRequestStateEnum = typeof UpdateStopRequestStateEnum[keyof typeof UpdateStopRequestStateEnum];


/**
 * Check if a given object implements the UpdateStopRequest interface.
 */
export function instanceOfUpdateStopRequest(value: object): value is UpdateStopRequest {
    return true;
}

export function UpdateStopRequestFromJSON(json: any): UpdateStopRequest {
    return UpdateStopRequestFromJSONTyped(json, false);
}

export function UpdateStopRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): UpdateStopRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'title': json['title'] == null ? undefined : json['title'],
        'description': json['description'] == null ? undefined : json['description'],
        'highlight': json['highlight'] == null ? undefined : json['highlight'],
        'index': json['index'] == null ? undefined : json['index'],
        'dayIds': json['dayIds'] == null ? undefined : json['dayIds'],
        'imageUrl': json['imageUrl'] == null ? undefined : json['imageUrl'],
        'imageId': json['imageId'] == null ? undefined : json['imageId'],
        'state': json['state'] == null ? undefined : json['state'],
    };
}

  export function UpdateStopRequestToJSON(json: any): UpdateStopRequest {
      return UpdateStopRequestToJSONTyped(json, false);
  }

  export function UpdateStopRequestToJSONTyped(value?: UpdateStopRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'title': value['title'],
        'description': value['description'],
        'highlight': value['highlight'],
        'index': value['index'],
        'dayIds': value['dayIds'],
        'imageUrl': value['imageUrl'],
        'imageId': value['imageId'],
        'state': value['state'],
    };
}

